/**
 * Authorized emails for workflow manager configuration management.
 * These users are allowed to create/delete workflow manager config rules.
 */
export const WORKFLOW_CONFIG_AUTHORIZED_EMAILS = [
  "andrew.hardin@encamp.com",
  "andrew.jackson@encamp.com",
  "ben@encamp.com",
  "casey.lee@encamp.com",
  "dan@encamp.com",
  "jack@encamp.com",
  "jaron.kennel@encamp.com",
  "jason.evans@encamp.com",
  "john.lieb-bauman@encamp.com",
  "john.zwissler@encamp.com",
  "jon.schmoll@encamp.com",
  "joshua.moyers@encamp.com",
  "liam.mcbride@encamp.com",
  "meaghan.crowell@encamp.com",
  "megan.kirkbride@encamp.com",
  "megan@encamp.com",
  "meredith.lind@encamp.com",
  "patrick@encamp.com",
  "simon.turner@encamp.com",
] as const;

